module.exports = __webpack_public_path__ + "img/img3.1d7af4c2.png";